import { render, staticRenderFns } from "./UpdateLicense.vue?vue&type=template&id=8af945da&"
import script from "./UpdateLicense.vue?vue&type=script&lang=js&"
export * from "./UpdateLicense.vue?vue&type=script&lang=js&"
import style0 from "./UpdateLicense.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports